export enum BinType {
  RETAIL = 'retail',
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
  BULKY = 'bulky',
  PALLET = 'pallet',
  LOOSE_CASE = 'loose_case',
  NONE = 'none',
}
